class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			
			this.onSubmitHandler(event);
		}, 800);

		const facetForm = this.querySelector('form');
		facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

		const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
		if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener('popstate', onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll('.js-facet-remove').forEach((element) => {
			element.classList.toggle('disabled', disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById('ProductCount');
		const countContainerDesktop = document.getElementById('ProductCountDesktop');
		const loadingSpinners = document.querySelectorAll(
			'.facets-container .loading__spinner, facet-filters-form .loading__spinner',
		);
		loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
		document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
		if (countContainer) {
			countContainer.classList.add('loading');
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add('loading');
		}

		const isHeadingOpen = document.querySelector('.facets__heading.open') !== null;
		sessionStorage.setItem('facets-heading-open', isHeadingOpen ? 'true' : 'false');

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = (element) => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}
	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText;

				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{ html, url },
				];

				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);
				FacetFiltersForm.renderQuickViewChips(html);

				FacetFiltersForm.initializeAfterRender();
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
		FacetFiltersForm.renderQuickViewChips(html);

		if (typeof initializeScrollAnimationTrigger === 'function') {
			initializeScrollAnimationTrigger(html.innerHTML);
		}

		FacetFiltersForm.initializeAfterRender();
	}

	static initializeAfterRender() {
		if (window.ajaxinateInstance) {
			window.ajaxinateInstance = null;
		}

		if (typeof window.custom_filters?.init === 'function') {
			window.custom_filters.init();
		}

		if (typeof window.custom_filters?.topPosition === 'function') {
			window.custom_filters.topPosition();
		}

		if (typeof window.custom_filters?.read_open_tab === 'function') {
			window.custom_filters.read_open_tab();
		}

		setTimeout(() => {
			if (typeof window.initAjaxinate === 'function') {
				window.initAjaxinate();
			}
		}, 0);

		setTimeout(() => {
			if (typeof window.readFilteredSwatches === 'function') {
				window.readFilteredSwatches();
			}

			if (typeof window.initCustomSortBy === 'function') {
				window.initCustomSortBy();
			}
		}, 20);
	}

	static renderProductGridContainer(html) {
		document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
			.parseFromString(html, 'text/html')
			.getElementById('ProductGridContainer').innerHTML;

		document
			.getElementById('ProductGridContainer')
			.querySelectorAll('.scroll-trigger')
			.forEach((element) => {
				element.classList.add('scroll-trigger--cancel');
			});
	}

	static renderProductCount(html) {
		const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
		const container = document.getElementById('ProductCount');
		const containerDesktop = document.getElementById('ProductCountDesktop');
		container.innerHTML = count;
		container.classList.remove('loading');
		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove('loading');
		}
		const loadingSpinners = document.querySelectorAll(
			'.facets-container .loading__spinner, facet-filters-form .loading__spinner',
		);
		loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
	}

	static renderQuickViewChips(html) {
		const focusedChip = document.activeElement?.closest?.('.quick-view-chips__checkbox');
		const focusedOption = focusedChip
			? { name: focusedChip.dataset.filterName, value: focusedChip.dataset.filterValue }
			: null;
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

		['quick-view-chips-desktop', 'quick-view-chips-mobile'].forEach((id) => {
			const source = parsedHTML.getElementById(id);
			const target = document.getElementById(id);
			if (source && target) {
				target.restoreMobilePanel?.();
				target.innerHTML = source.innerHTML;
			} else if (!source && target) {
				target.remove();
			}
		});

		const openSlug = window.__quickViewChipsOpenSlug;
		if (openSlug) {
			const matchingDetails = Array.from(
				document.querySelectorAll(`.quick-view-chips__chip[data-quick-view-slug="${openSlug}"]`),
			);
			const visibleDetails = matchingDetails.find((details) => {
				const host = details.closest('quick-view-chips');
				if (!host) return false;
				const styles = getComputedStyle(host);
				return styles.display !== 'none' && styles.visibility !== 'hidden' && host.getClientRects().length > 0;
			});
			visibleDetails?.setAttribute('open', '');

			if (focusedOption) {
				const restoreFocus = () => {
					const focusScope = visibleDetails?.closest('quick-view-chips') || document;
					const replacement = Array.from(focusScope.querySelectorAll('.quick-view-chips__checkbox')).find(
						(input) => input.dataset.filterName === focusedOption.name && input.dataset.filterValue === focusedOption.value,
					);
					replacement?.focus({ preventScroll: true });
				};
				window.requestAnimationFrame(restoreFocus);
			}
		}

		FacetFiltersForm.syncFacetOptionOrder();
	}

	static syncSidebarOptionOrder() {
		document.querySelectorAll('facet-filters-form .filter_wrap .wrap_body').forEach((group) => {
			const orderedItems = Array.from(group.children)
				.map((item, index) => ({
					item,
					index,
					order: Number.parseFloat(getComputedStyle(item).order),
				}))
				.filter(({ item }) => item.classList.contains('list-menu__item'));

			if (!orderedItems.some(({ order }) => Number.isFinite(order) && order !== 0)) return;

			const sortedItems = orderedItems
				.slice()
				.sort((a, b) => {
					const orderA = Number.isFinite(a.order) ? a.order : 0;
					const orderB = Number.isFinite(b.order) ? b.order : 0;
					return orderA - orderB || a.index - b.index;
				})
				.map(({ item }) => item);

			if (sortedItems.every((item, index) => item === orderedItems[index].item)) return;
			sortedItems.forEach((item) => group.appendChild(item));
		});
	}

	static syncQuickViewOptionOrder() {
		const sidebarInputs = Array.from(document.querySelectorAll('#FacetFiltersForm input[type="checkbox"]'));
		if (!sidebarInputs.length) return;
		document.querySelectorAll('.quick-view-chips__option').forEach((option) => {
			const input = option.querySelector('.quick-view-chips__checkbox');
			if (!input) return;
			const name = input.dataset.filterName;
			const value = input.dataset.filterValue;
			const sidebarItem = sidebarInputs.find((i) => i.name === name && i.value === value)?.closest('.list-menu__item');
			if (!sidebarItem) return;
			const order = getComputedStyle(sidebarItem).order;
			if (order && order !== '0') option.style.order = order;
		});
	}

	static syncFacetOptionOrder() {
		FacetFiltersForm.syncSidebarOptionOrder();
		FacetFiltersForm.syncQuickViewOptionOrder();
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
		const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
			'#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
		);
		const facetDetailsElementsFromDom = document.querySelectorAll(
			'#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
		);

		// Remove facets that are no longer returned from the server
		Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
			if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
				currentElement.remove();
			}
		});

		const matchesId = (element) => {
			const jsFilter = event ? event.target.closest('.js-filter') : undefined;
			return jsFilter ? element.id === jsFilter.id : false;
		};

		const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
		const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

		facetsToRender.forEach((elementToRender, index) => {
			const currentElement = document.getElementById(elementToRender.id);
			// Element already rendered in the DOM so just update the innerHTML
			if (currentElement) {
				document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
			} else {
				if (index > 0) {
					const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
					// Same facet type (eg horizontal/vertical or drawer/mobile)
					if (elementToRender.className === previousElementClassName) {
						document.getElementById(previousElementId).after(elementToRender);
						return;
					}
				}

				if (elementToRender.parentElement) {
					document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
				}
			}
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML, event);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender) {
			const closestJSFilterID = event.target.closest('.js-filter').id;

			if (closestJSFilterID) {
				FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
				FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

				const newFacetDetailsElement = document.getElementById(closestJSFilterID);
				const isMobileFacet = newFacetDetailsElement.classList.contains(
					'mobile-facets__details'
				);

				const inputName = event.target.getAttribute('name');
				const inputValue = event.target.getAttribute('value');

				const replacementInput =
					isMobileFacet && inputName
						? newFacetDetailsElement.querySelector(
								`input[name="${CSS.escape(inputName)}"][value="${CSS.escape(inputValue || '')}"]`
							)
						: null;

				const newElementSelector = isMobileFacet
					? `.filter_group_title`
					: `.facets__summary`;

				const newElementToActivate =
					replacementInput ||
					newFacetDetailsElement.querySelector(newElementSelector);

				const isTextInput = event.target.getAttribute('type') === 'text';

				if (newElementToActivate && !isTextInput) {
					newElementToActivate.focus();
				}
			}
		}
	}

	static renderActiveFacets(html, event) {
		const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
			
		});

		setTimeout(() => {
			if(event) {
				const target = event.target;

				const filters = document.querySelectorAll('#FacetsWrapperMobile input');
				filters.forEach(filter => {
					if(filter.value === target.value) {
						filter.scrollIntoView({
							behavior: 'smooth',
							block: 'center'
						});
					}
				})
			}
		}, 20)


		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

		mobileElementSelectors.forEach((selector) => {
			if (!html.querySelector(selector)) return;
			document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
		});

		document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
	}

	static renderCounts(source, target) {
		const targetSummary = target.querySelector('.facets__summary');
		const sourceSummary = source.querySelector('.facets__summary');

		if (sourceSummary && targetSummary) {
			targetSummary.outerHTML = sourceSummary.outerHTML;
		}

		const targetHeaderElement = target.querySelector('.facets__header');
		const sourceHeaderElement = source.querySelector('.facets__header');

		if (sourceHeaderElement && targetHeaderElement) {
			targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
		}

		const targetWrapElement = target.querySelector('.facets-wrap');
		const sourceWrapElement = source.querySelector('.facets-wrap');

		if (sourceWrapElement && targetWrapElement) {
			const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
			if (isShowingMore) {
				sourceWrapElement
					.querySelectorAll('.facets__item.hidden')
					.forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
			}

			targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
		}
	}

	static renderMobileCounts(source, target) {
		const targetFacetsList = target.querySelector('.mobile-facets__list');
		const sourceFacetsList = source.querySelector('.mobile-facets__list');

		if (sourceFacetsList && targetFacetsList) {
			targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
	}

	static getSections() {
		return [
			{
				section: document.getElementById('product-grid').dataset.id,
			},
		];
	}

	createSearchParams(form) {
		const formData = new FormData(form);
		return new URLSearchParams(formData).toString();
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onSubmitHandler(event) {
		event.preventDefault();
		const sortFilterForms = document.querySelectorAll('facet-filters-form form');
		if (event.srcElement.className == 'mobile-facets__checkbox') {
			const searchParams = this.createSearchParams(event.target.closest('form'));
			this.onSubmitForm(searchParams, event);
		} else {
			const forms = [];
			const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

			sortFilterForms.forEach((form) => {
				if (!isMobile) {
					if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
						forms.push(this.createSearchParams(form));
					}
				} else if (form.id === 'FacetFiltersFormMobile') {
					forms.push(this.createSearchParams(form));
				}
			});
			this.onSubmitForm(forms.join('&'), event);
		}
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url =
			event.currentTarget.href.indexOf('?') == -1
				? ''
				: event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
		FacetFiltersForm.renderPage(url);
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll('input').forEach((element) => {
			element.addEventListener('change', this.onRangeChange.bind(this));
			element.addEventListener('keydown', this.onKeyDown.bind(this));
		});
		this.setMinAndMaxValues();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	onKeyDown(event) {
		if (event.metaKey) return;

		const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
		if (!event.key.match(pattern)) event.preventDefault();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll('input');
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
		if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
		if (minInput.value === '') maxInput.setAttribute('data-min', 0);
		if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute('data-min'));
		const max = Number(input.getAttribute('data-max'));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const facetLink = this.querySelector('a');
		facetLink.setAttribute('role', 'button');
		facetLink.addEventListener('click', this.closeFilter.bind(this));
		facetLink.addEventListener('keyup', (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
		form.onActiveFilterClick(event);
		// custom_filters.topPosition();
	}
}

customElements.define('facet-remove', FacetRemove);

class QuickViewChips extends HTMLElement {
	constructor() {
		super();
		this.targetFormId = this.dataset.targetForm;
		this.onDocumentClick = this.onDocumentClick.bind(this);
		this.onPortaledChange = this.onPortaledChange.bind(this);
		this.onPortaledKeyup = this.onPortaledKeyup.bind(this);

		this.addEventListener('change', (event) => {
			if (event.target.classList.contains('quick-view-chips__checkbox')) {
				this.proxyChange(event.target);
			}
		});

		this.addEventListener('click', (event) => {
			const summary = event.target.closest('summary');
			if (!summary) return;

			const openDetails = summary.parentElement;
			const isMobile = this.classList.contains('quick-view-chips--mobile');
			if (isMobile) {
				event.preventDefault();
				this.ensureMobileChipVisible(summary);
			}

			this.querySelectorAll('details[open]').forEach((details) => {
				if (details !== openDetails) details.removeAttribute('open');
			});

			if (isMobile) {
				if (openDetails.open) openDetails.removeAttribute('open');
				else openDetails.setAttribute('open', '');
			}
		});

		this.addEventListener('keyup', (event) => {
			if (event.key === 'Escape' || event.code === 'Escape') this.closeAll();
		});

		this.addEventListener(
			'toggle',
			(event) => {
				const details = event.target.closest('.quick-view-chips__chip');
				details?.querySelector('.quick-view-chips__summary')?.setAttribute('aria-expanded', event.target.open ? 'true' : 'false');
				window.__quickViewChipsOpenSlug = this.querySelector('details[open]')?.dataset.quickViewSlug || '';
				if (!details) return;

				if (this.classList.contains('quick-view-chips--mobile')) {
					if (details.open) this.ensureMobileChipVisible(details.querySelector('.quick-view-chips__summary'));
					this.positionMobilePanel(details);
				}
			},
			true,
		);
	}

	ensureMobileChipVisible(summary) {
		if (!summary) return;
		const row = summary.closest('.quick-view-mobile-row');
		if (!row) return;
		if (!summary.parentElement?.open) {
			row.style.paddingRight = '320px';
			this.__grantedRow = row;
		}

		const rowRect = row.getBoundingClientRect();
		const summaryRect = summary.getBoundingClientRect();
		const viewportRight = document.documentElement.clientWidth || window.innerWidth;
		const visibleLeft = Math.max(0, rowRect.left);
		const visibleRight = Math.min(viewportRight, rowRect.right);
		const edgePadding = 8;

		if (summaryRect.left < visibleLeft + edgePadding) {
			row.scrollLeft += summaryRect.left - (visibleLeft + edgePadding);
		} else if (summaryRect.right > visibleRight - edgePadding) {
			row.scrollLeft += summaryRect.right - (visibleRight - edgePadding);
		}
	}

	portalMobilePanel(details) {
		if (!details || this.__portaledPanel) return this.__portaledPanel;
		const panel = details.querySelector('.quick-view-chips__panel');
		if (!panel || !document.documentElement) return panel;

		const portalLayer = document.createElement('div');
		portalLayer.className = 'quick-view-chips__portal-layer';
		document.documentElement.appendChild(portalLayer);
		this.__portalLayer = portalLayer;
		this.__panelPlaceholder = document.createComment('quick-view-chips-panel');
		panel.parentNode.insertBefore(this.__panelPlaceholder, panel);
		portalLayer.appendChild(panel);
		panel.dataset.quickViewPortaled = 'true';
		panel.addEventListener('change', this.onPortaledChange);
		panel.addEventListener('keyup', this.onPortaledKeyup);

		const summary = details.querySelector('.quick-view-chips__summary');
		if (summary) {
			if (!summary.id) summary.id = `${this.id || 'quick-view-chips'}-${details.dataset.quickViewSlug}-summary`;
			if (!panel.id) panel.id = `${this.id || 'quick-view-chips'}-${details.dataset.quickViewSlug}-panel`;
			summary.setAttribute('aria-controls', panel.id);
			summary.setAttribute('aria-owns', panel.id);
			panel.setAttribute('aria-labelledby', summary.id);
			this.__portaledSummary = summary;
		}

		this.__portaledPanel = panel;
		return panel;
	}

	restoreMobilePanel() {
		if (this.__grantedRow) {
			this.__grantedRow.style.paddingRight = '';
			this.__grantedRow = null;
		}

		const panel = this.__portaledPanel;
		if (!panel) return;

		panel.removeEventListener('change', this.onPortaledChange);
		panel.removeEventListener('keyup', this.onPortaledKeyup);
		this.__portaledSummary?.removeAttribute('aria-controls');
		this.__portaledSummary?.removeAttribute('aria-owns');
		panel.removeAttribute('aria-labelledby');
		this.__portaledSummary = null;
		delete panel.dataset.quickViewPortaled;

		if (this.__panelPlaceholder?.parentNode) {
			this.__panelPlaceholder.parentNode.insertBefore(panel, this.__panelPlaceholder);
			this.__panelPlaceholder.remove();
		} else {
			panel.remove();
		}

		this.__portalLayer?.remove();
		this.__portaledPanel = null;
		this.__portalLayer = null;
		this.__panelPlaceholder = null;
	}

	positionMobilePanel(details) {
		const summary = details.querySelector('.quick-view-chips__summary');
		const panel = details.open
			? this.portalMobilePanel(details)
			: this.__portaledPanel || details.querySelector('.quick-view-chips__panel');
		if (!summary || !panel) return;

		const row = summary.closest('.quick-view-mobile-row');
		if (!details.open) {
			if (row) row.style.paddingRight = '';
			this.__grantedRow = null;
			panel.style.position = '';
			panel.style.top = '';
			panel.style.left = '';
			panel.style.minWidth = '';
			panel.style.zIndex = '';
			this.restoreMobilePanel();
			return;
		}

		if (row) {
			row.style.paddingRight = '320px';
			this.__grantedRow = row;
		}
		if (window.scrollX !== 0) window.scrollTo(0, window.scrollY);
		this.ensureMobileChipVisible(summary);

		const rect = summary.getBoundingClientRect();
		panel.style.position = 'fixed';
		panel.style.zIndex = '1';
		panel.style.top = `${rect.bottom - 1}px`;
		panel.style.left = `${rect.left}px`;
		panel.style.minWidth = `${rect.width}px`;

		const panelWidth = panel.getBoundingClientRect().width;
		const viewportRight = document.documentElement.clientWidth || window.innerWidth;
		const maxLeft = viewportRight - panelWidth - 8;
		let panelLeft = rect.left;
		if (row && (panelLeft < 8 || panelLeft > maxLeft)) {
			row.scrollLeft += panelLeft < 8 ? panelLeft - 8 : panelLeft - maxLeft;
			const repositionedRect = summary.getBoundingClientRect();
			panelLeft = repositionedRect.left;
			panel.style.top = `${repositionedRect.bottom - 1}px`;
		}

		const clampedLeft = Math.max(8, Math.min(panelLeft, maxLeft));
		panel.style.left = `${Math.abs(clampedLeft - panelLeft) < 1 ? panelLeft : clampedLeft}px`;
		if (row) this.trimRowTrack(row);
	}

	trimRowTrack(row) {
		const track = Number.parseFloat(row.style.paddingRight) || 0;
		if (track === 0) return;
		const naturalMax = Math.max(0, row.scrollWidth - track - row.clientWidth);
		const needed = Math.min(track, Math.max(0, Math.ceil(row.scrollLeft - naturalMax)));
		const value = needed > 0 ? `${needed}px` : '';
		if (row.style.paddingRight !== value) row.style.paddingRight = value;
	}

	repositionMobilePanel(details) {
		if (!details?.open) return;
		const summary = details.querySelector('.quick-view-chips__summary');
		const panel = this.__portaledPanel;
		if (!summary || !panel) return;

		const rect = summary.getBoundingClientRect();
		const row = summary.closest('.quick-view-mobile-row');
		const viewportRight = document.documentElement.clientWidth || window.innerWidth;
		if (row) {
			const rowRect = row.getBoundingClientRect();
			const visibleLeft = Math.max(0, rowRect.left);
			const visibleRight = Math.min(viewportRight, rowRect.right);
			if (rect.right <= visibleLeft || rect.left >= visibleRight) {
				this.closeAll();
				return;
			}
		}

		const panelWidth = panel.getBoundingClientRect().width;
		const maxLeft = viewportRight - panelWidth - 8;
		const clampedLeft = Math.max(8, Math.min(rect.left, maxLeft));
		if (row) this.trimRowTrack(row);
		panel.style.top = `${rect.bottom - 1}px`;
		panel.style.left = `${Math.abs(clampedLeft - rect.left) < 1 ? rect.left : clampedLeft}px`;
	}

	connectedCallback() {
		document.addEventListener('click', this.onDocumentClick);
		this.onAnyScroll = this.onAnyScroll || ((event) => {
			if (!this.classList.contains('quick-view-chips--mobile')) return;
			const openDetails = this.querySelector('details[open]');
			if (!openDetails) return;
			if (event.target instanceof Element && event.target.closest('.quick-view-chips__panel')) return;

			const scrollRow = event.target instanceof Element ? event.target.closest('.quick-view-mobile-row') : null;
			if (scrollRow) {
				this.repositionMobilePanel(openDetails);
				return;
			}
			this.closeAll();
		});
		document.addEventListener('scroll', this.onAnyScroll, { capture: true, passive: true });
	}

	disconnectedCallback() {
		this.restoreMobilePanel();
		document.removeEventListener('click', this.onDocumentClick);
		document.removeEventListener('scroll', this.onAnyScroll, { capture: true });
	}

	onDocumentClick(event) {
		if (!this.contains(event.target) && !this.__portaledPanel?.contains(event.target)) this.closeAll();
	}

	onPortaledChange(event) {
		if (event.target.classList.contains('quick-view-chips__checkbox')) {
			this.proxyChange(event.target);
		}
	}

	onPortaledKeyup(event) {
		if (event.key === 'Escape' || event.code === 'Escape') {
			event.preventDefault();
			const summary = this.__portaledSummary;
			this.closeAll();
			summary?.focus({ preventScroll: true });
		}
	}

	closeAll() {
		this.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
	}

	proxyChange(chipInput) {
		const form = document.getElementById(this.targetFormId);
		if (!form) return;

		const name = chipInput.dataset.filterName;
		const value = chipInput.dataset.filterValue;
		const master = Array.from(form.querySelectorAll('input[type="checkbox"], input[type="radio"]')).find(
			(input) => input.name === name && input.value === value,
		);
		if (!master) return;

		master.checked = chipInput.checked;
		master.dispatchEvent(new Event('input', { bubbles: true }));
	}
}

customElements.define('quick-view-chips', QuickViewChips);

document.addEventListener('DOMContentLoaded', () => FacetFiltersForm.syncFacetOptionOrder());
